import type { ReportBundle } from "@/lib/parcelq/types";
import { Errors } from "@/lib/parcelq/errors";

export const Radius_Miles_Default = 1.5;
export const Radius_Miles_Min = 0.25;
export const Radius_Miles_Max = 2;

export function Bundle_Uses_Radius(Bundle: ReportBundle): boolean {
  return Bundle === "amenities" || Bundle === "complete";
}

export function Tier_Uses_Radius(Tier_Id: string): boolean {
  return Tier_Id === "radius-amenities" || Tier_Id === "combo";
}

/** Normalize / validate amenity search radius. Returns undefined when bundle ignores radius. */
export function Radius_Miles_Resolve(
  Bundle: ReportBundle,
  Raw: number | null | undefined,
): number | undefined {
  if (!Bundle_Uses_Radius(Bundle)) {
    return undefined;
  }

  const Value = Raw == null || Number.isNaN(Number(Raw)) ? Radius_Miles_Default : Number(Raw);
  if (Value < Radius_Miles_Min || Value > Radius_Miles_Max) {
    throw Errors.Radius_Invalid(
      `radius_miles must be between ${Radius_Miles_Min} and ${Radius_Miles_Max}`,
    );
  }
  return Math.round(Value * 100) / 100;
}
